/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filterpresetpunch2Inputs */

const en_filterpresetpunch2 = /** @type {(inputs: Filterpresetpunch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punch`)
};

const de_filterpresetpunch2 = /** @type {(inputs: Filterpresetpunch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kräftig`)
};

/**
* | output |
* | --- |
* | "Punch" |
*
* @param {Filterpresetpunch2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const filterpresetpunch2 = /** @type {((inputs?: Filterpresetpunch2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filterpresetpunch2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filterpresetpunch2(inputs)
	return de_filterpresetpunch2(inputs)
});
export { filterpresetpunch2 as "filterPresetPunch" }